import * as Sentry from '@sentry/react';

// Environment is classified by the Supabase project ref in VITE_SUPABASE_URL
// (same signal the app already builds against), not a hostname — the prod and
// staging web builds differ only by their env. No DSN, or an unknown project →
// Sentry stays OFF (local dev never reports).
const env = (import.meta as unknown as { env?: Record<string, string> & { DEV?: boolean } }).env ?? {};
const SUPABASE_URL = env.VITE_SUPABASE_URL ?? '';
const DSN = env.VITE_SENTRY_DSN ?? '';

function resolveEnvironment(): 'production' | 'staging' | null {
  if (SUPABASE_URL.includes('ejmdrazmuqrkuxlgnnlk')) return 'production';
  if (SUPABASE_URL.includes('lbkmfutwyjgzqmebsxyp')) return 'staging';
  return null; // local / unknown → keep Sentry off
}

// Student work carries names; assignment/submission URLs carry ids. Redact PII
// from every event before it leaves the browser (PDPO).
function scrubText(s: string): string {
  return s
    .replace(/[\w.+-]+@[\w-]+\.[\w.-]+/g, '[email]')
    .replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi, '[uuid]');
}

export function initSentry(): void {
  const environment = resolveEnvironment();
  if (!DSN || !environment) {
    if (env.DEV) console.info('[sentry] disabled (no DSN or local env)');
    return;
  }
  Sentry.init({
    dsn: DSN,
    environment,
    tracesSampleRate: environment === 'production' ? 0.1 : 1.0,
    beforeSend(event) {
      if (event.request?.url) event.request.url = scrubText(event.request.url);
      if (event.message) event.message = scrubText(event.message);
      for (const ex of event.exception?.values ?? []) {
        if (ex.value) ex.value = scrubText(ex.value);
      }
      return event;
    },
  });
}
